/* eslint-disable no-redeclare */
import { z } from 'zod';

export const HasInsurance = z.enum(['YES', 'NO']);

export type HasInsurance = z.infer<typeof HasInsurance>;
